module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAnexo()
      }
    }
  }, [_vm._v("\n    Log de Preventivas\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97dc236c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planilha/planilhas-operacional/ExportLogPreventivas.vue
// module id = 1018
// module chunks = 1